<template>
  <div>
    <span
      class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
      :class="paymentStatusOption?.classes ?? 'bg-gray-100 text-gray-800'"
    >
      <template v-if="orderNumber"> Order #{{ orderNumber }} - </template>
      {{ paymentStatusOption?.label ?? 'No Status' }}
    </span>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

import PaymentStatusOptions from '@/Utils/Orders/PaymentStatusOptions'

const props = defineProps({
  paymentStatus: {
    type: String,
    required: true
  },
  orderNumber: {
    type: String,
    default: null
  }
})

const paymentStatusOption = computed(() => {
  return PaymentStatusOptions.find((status) => status.value === props.paymentStatus.toUpperCase())
})
</script>
